var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlomoLogoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 20,
    viewBox: "0 0 105 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5582 15.4475V0.00567637H23.0885V19.9396L35.1009 19.9396V15.4475H27.5582Z",
    fill: "#2A3055"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.0665 19.9396C53.337 19.9396 56.9278 15.512 56.9278 10.0503C56.9278 4.25136 53.0958 0.00568922 46.9861 0.00568922C40.8764 0.00568922 36.9373 4.30314 37.0981 10.0503C37.2589 15.7975 40.5013 19.9396 47.0665 19.9396ZM47.0326 16.6415C50.1715 16.6415 52.716 13.6577 52.716 9.9769C52.716 6.29613 50.1715 3.31228 47.0326 3.31228C43.8937 3.31228 41.3492 6.29613 41.3492 9.9769C41.3492 13.6577 43.8937 16.6415 47.0326 16.6415Z",
    fill: "#2A3055"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.6842 19.9396C100.955 19.9396 104.545 15.512 104.545 10.0503C104.545 4.25136 100.713 0.00568922 94.6038 0.00568922C88.4941 0.00568922 84.555 4.30314 84.7157 10.0503C84.8765 15.7975 88.119 19.9396 94.6842 19.9396ZM94.5991 16.6777C97.7218 16.6777 100.253 13.6873 100.253 9.99855C100.253 6.30975 97.7218 3.31938 94.5991 3.31938C91.4764 3.31938 88.9449 6.30975 88.9449 9.99855C88.9449 13.6873 91.4764 16.6777 94.5991 16.6777Z",
    fill: "#2A3055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2803 0.00568922L70.9349 12.536L65.3585 0.0337229L60.3435 0.0337227V19.9396H65.3585V11.6317L69.4924 19.9396H72.8447L76.2803 12.5255V19.9396H81.2953V0.00568922H76.2803Z",
    fill: "#2A3055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5393 19.8614C11.0817 19.9124 10.6077 19.9387 10.1174 19.9387C8.94816 19.9387 7.88279 19.8111 6.91999 19.5694C5.15463 19.0126 3.50577 17.9854 2.30009 16.6426C1.87628 16.1705 1.5549 15.6963 1.33527 15.2503C0.92852 14.5859 0.644767 13.8644 0.447127 13.1674C0.182719 12.1986 0.0356992 11.1523 0.00432723 10.0466C0.00213533 9.96935 0.000694485 9.89236 0 9.81564C0.00108819 9.71557 0.00362912 9.66112 0.00362912 9.66112C0.00362912 9.66112 0.00362912 8.15054 0.447438 6.79102C0.506795 6.46781 0.609197 6.1096 0.75636 5.73151C2.16389 2.31551 5.44846 0.0514426 9.88123 0C14.4417 0.050019 16.9165 2.18348 17.5887 3.30498L15.1107 5.82139C14.2199 4.86964 13.3346 4.27635 12.4986 3.9181C11.7638 3.52561 10.9455 3.30664 10.083 3.30664C8.26405 3.30664 6.64183 4.28046 5.58506 5.80176C4.91959 6.68325 4.42048 7.78574 4.29434 9.05688C4.06468 11.3711 4.37142 11.9791 4.98777 13.2007C5.04951 13.3231 5.11436 13.4516 5.18208 13.5886C5.26242 13.7096 5.35816 13.8378 5.46807 13.9704C6.5199 15.5911 8.19553 16.6397 10.083 16.6397C11.64 16.6397 13.0529 16.2655 14.0904 15.1058V18.8822C13.3188 19.4398 12.4522 19.6656 11.5393 19.8614Z",
    fill: "#2A3055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.28563 8.45924H19.9732V20H16.6339V11.8284H8.28563V8.45924Z",
    fill: "#2A3055"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlomoLogoBlue);
export default __webpack_public_path__ + "static/media/glomo_logo_blue.738833eef28ff263214ecab467bbd3a6.svg";
export { ForwardRef as ReactComponent };